import API from './axios.js';

export const getMyClients = (queryParams = '') => API.get(`clients${queryParams}`);
export const getMyClientsByID = (id) => API.get(`clients/${id}`);

export const getCourtTypeByCourtRef = (courtRef) => API.get(`case/type/${courtRef}`);

export const addMyClient = (data) => API.post(`clients`,data);
export const updateMyClient = (client_id,payload) => API.put(`clients/${client_id}`,payload);
export const deleteMyClient = (client_id) => API.delete(`clients/${client_id}`);